// extracted by mini-css-extract-plugin
module.exports = {"select":"CarrouselSelectorMobile_select__PUC3_","input":"CarrouselSelectorMobile_input__8LHbt"};